import { fromFetch } from 'rxjs/fetch';
import { FleetJwtAuthHeaders } from '../../models/fleet-jwt-auth-headers';
import { requiredHeaders } from '../../models/required-headers';
import { ignoreData } from '../../utils/ignore-data';
import { fleetEnvironment } from './fleet-environment';

export function putMapSetsVehicleGroupAssignments(
  id: number,
  vehicleGroupIds: number[]
) {
  return fromFetch(
    new Request(fleetEnvironment.mapSetsVehicleGroupsAssignmentUrl(id), {
      method: 'PUT',
      headers: {
        ...requiredHeaders,
        ...new FleetJwtAuthHeaders(),
      },
      body: JSON.stringify(vehicleGroupIds),
    })
  ).pipe(ignoreData());
}
